// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"375af977","539":"de587070"}[chunkId] + ".chunk.js";
};